module.exports = __webpack_public_path__ + "img/IMGP8628.7356c777.jpg";